import API from '@/api/base'

API.define(
  'categoryBySlug',
  {
    categorySlug: '',
    siteSlug: '',
  },
  {
    collectionPath: 'shop_item_category/slug',
  }
)

export const state = {
  siteId: '',
  shopCategories: [],
}

export const getters = {
  getShopCategories: ({ shopCategories }) => shopCategories,
  getShopCategory: (state) => (categoryId) => {
    return state.shopCategories.find((category) => {
      return category.id === categoryId
    })
  },
  // getShopItem: ({ shopCategories }) => (categoryId, itemId) => {
  //   // search through shopItems for shopItemCategory
  //   const category = shopCategories.find((cat) => cat.id === categoryId)
  //   // then search through shopItemCategory for shopItemId
  //   return category.shopItems.find((item) => item.id === itemId)
  // },
}

export const actions = {
  fetchShopCategories: ({ commit, state }, siteId) => {
    // Return cached data if it matches site id
    if (state.siteId && state.siteId === siteId) {
      return state.shopCategories
    }
    const request = new Promise((resolve, reject) => {
      API.findAll('shopItemCategory', {
        query: {
          site_id: siteId,
        },
        include_items: true,
      })
        .then((response) => {
          commit('SET_SHOP_CATEGORY_SITE_ID', siteId)
          commit(
            'SET_SHOP_CATEGORIES',
            response.data.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
          )
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response)
        })
      // resolve(state.shopCategories)
    })
    return request
  },
  fetchShopCategoryBySlug: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      API.findAll('categoryBySlug', {
        query: {
          category_slug: params.categorySlug,
          site_slug: params.siteSlug,
        },
      })
        .then((response) => {
          // TODO: Add this to the store
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response)
        })
    }),
}

export const mutations = {
  SET_SHOP_CATEGORY_SITE_ID(state, siteId) {
    state.siteId = siteId
  },
  SET_SHOP_CATEGORIES(state, shopCategories) {
    state.shopCategories = shopCategories
  },
}
